import { useSelector } from "react-redux";
import { selectUser } from "../reducers/userSlice";

export const UrlWs = "https://gateway.penalolen.cl:9443";

export const redireccionCu= window.location.origin+"/login";

export const listado_comunas = [
  {
    id: "13122",
    nombre: "PEÑALOLEN"
  },
  {
    id: "13502",
    nombre: "ALHUÉ"
  },
  {
    id: "15101",
    nombre: "Arica"
  },
  {
    id: "13402",
    nombre: "BUIN"
  },
  {
    id: "13403",
    nombre: "CALERA DE TANGO"
  },
  {
    id: "13102",
    nombre: "CERRILLOS"
  },
  {
    id: "13103",
    nombre: "CERRO NAVIA"
  },
  {
    id: "10401",
    nombre: "Chaitén"
  },
  {
    id: "13301",
    nombre: "COLINA"
  },
  {
    id: "13104",
    nombre: "CONCHALÍ"
  },
  {
    id: "13503",
    nombre: "CURACAVÍ"
  },
  {
    id: "6105",
    nombre: "Doñihue"
  },
  {
    id: "13105",
    nombre: "EL BOSQUE"
  },
  {
    id: "13602",
    nombre: "EL MONTE"
  },
  {
    id: "13106",
    nombre: "ESTACIÓN CENTRAL"
  },
  {
    id: "8104",
    nombre: "Florida"
  },
  {
    id: "13107",
    nombre: "HUECHURABA"
  },
  {
    id: "13108",
    nombre: "INDEPENDENCIA"
  },
  {
    id: "13603",
    nombre: "ISLA DE MAIPO"
  },
  {
    id: "13109",
    nombre: "LA CISTERNA"
  },
  {
    id: "13110",
    nombre: "LA FLORIDA"
  },
  {
    id: "13111",
    nombre: "LA GRANJA"
  },
  {
    id: "13112",
    nombre: "LA PINTANA"
  },
  {
    id: "13113",
    nombre: "LA REINA"
  },
  {
    id: "13302",
    nombre: "LAMPA"
  },
  {
    id: "13114",
    nombre: "LAS CONDES"
  },
  {
    id: "13115",
    nombre: "LO BARNECHEA"
  },
  {
    id: "13116",
    nombre: "LO ESPEJO"
  },
  {
    id: "13117",
    nombre: "LO PRADO"
  },
  {
    id: "13118",
    nombre: "MACUL"
  },
  {
    id: "13119",
    nombre: "MAIPÚ"
  },
  {
    id: "13504",
    nombre: "MARÍA PINTO"
  },
  {
    id: "13501",
    nombre: "MELIPILLA"
  },
  {
    id: "13120",
    nombre: "ÑUÑOA"
  },
  {
    id: "13604",
    nombre: "PADRE HURTADO"
  },
  {
    id: "13404",
    nombre: "PAINE"
  },
  {
    id: "13121",
    nombre: "PEDRO AGUIRRE CERDA"
  },
  {
    id: "13605",
    nombre: "PEÑAFLOR"
  },
  
  {
    id: "13202",
    nombre: "PIRQUE"
  },
  {
    id: "13123",
    nombre: "PROVIDENCIA"
  },
  {
    id: "13124",
    nombre: "PUDAHUEL"
  },
  {
    id: "13201",
    nombre: "PUENTE ALTO"
  },
  {
    id: "13125",
    nombre: "QUILICURA"
  },
  {
    id: "13126",
    nombre: "QUINTA NORMAL"
  },
  {
    id: "13127",
    nombre: "RECOLETA"
  },
  {
    id: "13128",
    nombre: "RENCA"
  },
  {
    id: "13401",
    nombre: "SAN BERNARDO"
  },
  {
    id: "13129",
    nombre: "SAN JOAQUÍN"
  },
  {
    id: "13203",
    nombre: "SAN JOSÉ DE MAIPO"
  },
  {
    id: "13130",
    nombre: "SAN MIGUEL"
  },
  {
    id: "13505",
    nombre: "SAN PEDRO"
  },
  {
    id: "13131",
    nombre: "SAN RAMÓN"
  },
  {
    id: "13101",
    nombre: "SANTIAGO"
  },
  {
    id: "13601",
    nombre: "TALAGANTE"
  },
  {
    id: "13303",
    nombre: "TILTIL"
  },
  {
    id: "13132",
    nombre: "VITACURA"
  },
  {
    id: "5405",
    nombre: "Zapallar"
  },
  {
    id: "11201",
    nombre: "Aisén"
  },
  {
    id: "5602",
    nombre: "Algarrobo"
  },
  {
    id: "8314",
    nombre: "Alto Biobío"
  },
  {
    id: "3302",
    nombre: "Alto del Carmen"
  },
  {
    id: "1107",
    nombre: "Alto Hospicio"
  },
  {
    id: "10202",
    nombre: "Ancud"
  },
  {
    id: "4103",
    nombre: "Andacollo"
  },
  {
    id: "9201",
    nombre: "Angol"
  },
  {
    id: "12202",
    nombre: "Antártica"
  },
  {
    id: "2101",
    nombre: "Antofagasta"
  },
  {
    id: "8302",
    nombre: "Antuco"
  },
  {
    id: "8202",
    nombre: "Arauco"
  },
  {
    id: "8402",
    nombre: "Bulnes"
  },
  {
    id: "5402",
    nombre: "Cabildo"
  },
  {
    id: "12201",
    nombre: "Cabo de Hornos"
  },
  {
    id: "8303",
    nombre: "Cabrero"
  },
  {
    id: "2201",
    nombre: "Calama"
  },
  {
    id: "10102",
    nombre: "Calbuco"
  },
  {
    id: "3102",
    nombre: "Caldera"
  },
  {
    id: "5502",
    nombre: "Calera"
  },
  {
    id: "5302",
    nombre: "Calle Larga"
  },
  {
    id: "15102",
    nombre: "Camarones"
  },
  {
    id: "1402",
    nombre: "Camiña"
  },
  {
    id: "4202",
    nombre: "Canela"
  },
  {
    id: "8203",
    nombre: "Cañete"
  },
  {
    id: "9102",
    nombre: "Carahue"
  },
  {
    id: "5603",
    nombre: "Cartagena"
  },
  {
    id: "5102",
    nombre: "Casablanca"
  },
  {
    id: "10201",
    nombre: "Castro"
  },
  {
    id: "5702",
    nombre: "Catemu"
  },
  {
    id: "7201",
    nombre: "Cauquenes"
  },
  {
    id: "7202",
    nombre: "Chanco"
  },
  {
    id: "3201",
    nombre: "Chañaral"
  },
  {
    id: "6302",
    nombre: "Chépica"
  },
  {
    id: "8103",
    nombre: "Chiguayante"
  },
  {
    id: "11401",
    nombre: "Chile Chico"
  },
  {
    id: "8401",
    nombre: "Chillán"
  },
  {
    id: "8406",
    nombre: "Chillán Viejo"
  },
  {
    id: "6303",
    nombre: "Chimbarongo"
  },
  {
    id: "9121",
    nombre: "Cholchol"
  },
  {
    id: "10203",
    nombre: "Chonchi"
  },
  {
    id: "11202",
    nombre: "Cisnes"
  },
  {
    id: "8403",
    nombre: "Cobquecura"
  },
  {
    id: "10103",
    nombre: "Cochamó"
  },
  {
    id: "11301",
    nombre: "Cochrane"
  },
  {
    id: "6102",
    nombre: "Codegua"
  },
  {
    id: "8404",
    nombre: "Coelemu"
  },
  {
    id: "11101",
    nombre: "Coihaique"
  },
  {
    id: "8405",
    nombre: "Coihueco"
  },
  {
    id: "6103",
    nombre: "Coinco"
  },
  {
    id: "7402",
    nombre: "Colbún"
  },
  {
    id: "1403",
    nombre: "Colchane"
  },
  {
    id: "9202",
    nombre: "Collipulli"
  },
  {
    id: "6104",
    nombre: "Coltauco"
  },
  {
    id: "4302",
    nombre: "Combarbalá"
  },
  {
    id: "8101",
    nombre: "Concepción"
  },
  {
    id: "5103",
    nombre: "Concón"
  },
  {
    id: "7102",
    nombre: "Constitución"
  },
  {
    id: "8204",
    nombre: "Contulmo"
  },
  {
    id: "3101",
    nombre: "Copiapó"
  },
  {
    id: "4102",
    nombre: "Coquimbo"
  },
  {
    id: "8102",
    nombre: "Coronel"
  },
  {
    id: "14102",
    nombre: "Corral"
  },
  {
    id: "9103",
    nombre: "Cunco"
  },
  {
    id: "9203",
    nombre: "Curacautín"
  },
  {
    id: "10204",
    nombre: "Curaco de Vélez"
  },
  {
    id: "8205",
    nombre: "Curanilahue"
  },
  {
    id: "9104",
    nombre: "Curarrehue"
  },
  {
    id: "7103",
    nombre: "Curepto"
  },
  {
    id: "7301",
    nombre: "Curicó"
  },
  {
    id: "10205",
    nombre: "Dalcahue"
  },
  {
    id: "3202",
    nombre: "Diego de Almagro"
  },
  {
    id: "8407",
    nombre: "El Carmen"
  },
  {
    id: "5604",
    nombre: "El Quisco"
  },
  {
    id: "5605",
    nombre: "El Tabo"
  },
  {
    id: "7104",
    nombre: "Empedrado"
  },
  {
    id: "9204",
    nombre: "Ercilla"
  },
  {
    id: "9105",
    nombre: "Freire"
  },
  {
    id: "3303",
    nombre: "Freirina"
  },
  {
    id: "10104",
    nombre: "Fresia"
  },
  {
    id: "10105",
    nombre: "Frutillar"
  },
  {
    id: "10402",
    nombre: "Futaleufú"
  },
  {
    id: "14202",
    nombre: "Futrono"
  },
  {
    id: "9106",
    nombre: "Galvarino"
  },
  {
    id: "15202",
    nombre: "General Lagos"
  },
  {
    id: "9107",
    nombre: "Gorbea"
  },
  {
    id: "6106",
    nombre: "Graneros"
  },
  {
    id: "11203",
    nombre: "Guaitecas"
  },
  {
    id: "5503",
    nombre: "Hijuelas"
  },
  {
    id: "10403",
    nombre: "Hualaihué"
  },
  {
    id: "7302",
    nombre: "Hualañé"
  },
  {
    id: "8112",
    nombre: "Hualpén"
  },
  {
    id: "8105",
    nombre: "Hualqui"
  },
  {
    id: "1404",
    nombre: "Huara"
  },
  {
    id: "3304",
    nombre: "Huasco"
  },
  {
    id: "4201",
    nombre: "Illapel"
  },
  {
    id: "1101",
    nombre: "Iquique"
  },
  {
    id: "5201",
    nombre: "Isla de Pascua"
  },
  {
    id: "5104",
    nombre: "Juan Fernández"
  },
  {
    id: "5504",
    nombre: "La Cruz"
  },
  {
    id: "6202",
    nombre: "La Estrella"
  },
  {
    id: "4104",
    nombre: "La Higuera"
  },
  {
    id: "5401",
    nombre: "La Ligua"
  },
  {
    id: "4101",
    nombre: "La Serena"
  },
  {
    id: "14201",
    nombre: "La Unión"
  },
  {
    id: "14203",
    nombre: "Lago Ranco"
  },
  {
    id: "11102",
    nombre: "Lago Verde"
  },
  {
    id: "12102",
    nombre: "Laguna Blanca"
  },
  {
    id: "8304",
    nombre: "Laja"
  },
  {
    id: "14103",
    nombre: "Lanco"
  },
  {
    id: "6107",
    nombre: "Las Cabras"
  },
  {
    id: "9108",
    nombre: "Lautaro"
  },
  {
    id: "8201",
    nombre: "Lebu"
  },
  {
    id: "7303",
    nombre: "Licantén"
  },
  {
    id: "5802",
    nombre: "Limache"
  },
  {
    id: "7401",
    nombre: "Linares"
  },
  {
    id: "6203",
    nombre: "Litueche"
  },
  {
    id: "5703",
    nombre: "Llaillay"
  },
  {
    id: "10107",
    nombre: "Llanquihue"
  },
  {
    id: "6304",
    nombre: "Lolol"
  },
  {
    id: "9109",
    nombre: "Loncoche"
  },
  {
    id: "7403",
    nombre: "Longaví"
  },
  {
    id: "9205",
    nombre: "Lonquimay"
  },
  {
    id: "8206",
    nombre: "Los Alamos"
  },
  {
    id: "5301",
    nombre: "Los Andes"
  },
  {
    id: "8301",
    nombre: "Los Angeles"
  },
  {
    id: "14104",
    nombre: "Los Lagos"
  },
  {
    id: "10106",
    nombre: "Los Muermos"
  },
  {
    id: "9206",
    nombre: "Los Sauces"
  },
  {
    id: "4203",
    nombre: "Los Vilos"
  },
  {
    id: "8106",
    nombre: "Lota"
  },
  {
    id: "9207",
    nombre: "Lumaco"
  },
  {
    id: "6108",
    nombre: "Machalí"
  },
  {
    id: "14105",
    nombre: "Máfil"
  },
  {
    id: "6109",
    nombre: "Malloa"
  },
  {
    id: "6204",
    nombre: "Marchihue"
  },
  {
    id: "2302",
    nombre: "María Elena"
  },
  {
    id: "14106",
    nombre: "Mariquina"
  },
  {
    id: "7105",
    nombre: "Maule"
  },
  {
    id: "10108",
    nombre: "Maullín"
  },
  {
    id: "2102",
    nombre: "Mejillones"
  },
  {
    id: "9110",
    nombre: "Melipeuco"
  },
  {
    id: "7304",
    nombre: "Molina"
  },
  {
    id: "4303",
    nombre: "Monte Patria"
  },
  {
    id: "6110",
    nombre: "Mostazal"
  },
  {
    id: "8305",
    nombre: "Mulchén"
  },
  {
    id: "8306",
    nombre: "Nacimiento"
  },
  {
    id: "6305",
    nombre: "Nancagua"
  },
  {
    id: "12401",
    nombre: "Natales"
  },
  {
    id: "6205",
    nombre: "Navidad"
  },
  {
    id: "8307",
    nombre: "Negrete"
  },
  {
    id: "8408",
    nombre: "Ninhue"
  },
  {
    id: "5506",
    nombre: "Nogales"
  },
  {
    id: "9111",
    nombre: "Nueva Imperial"
  },
  {
    id: "8409",
    nombre: "Ñiquén"
  },
  {
    id: "11302",
    nombre: "OHiggins"
  },
  {
    id: "6111",
    nombre: "Olivar"
  },
  {
    id: "2202",
    nombre: "Ollagüe"
  },
  {
    id: "5803",
    nombre: "Olmué"
  },
  {
    id: "10301",
    nombre: "Osorno"
  },
  {
    id: "4301",
    nombre: "Ovalle"
  },
  {
    id: "9112",
    nombre: "Padre Las Casas"
  },
  {
    id: "4105",
    nombre: "Paiguano"
  },
  {
    id: "14107",
    nombre: "Paillaco"
  },
  {
    id: "10404",
    nombre: "Palena"
  },
  {
    id: "6306",
    nombre: "Palmilla"
  },
  {
    id: "14108",
    nombre: "Panguipulli"
  },
  {
    id: "5704",
    nombre: "Panquehue"
  },
  {
    id: "5403",
    nombre: "Papudo"
  },
  {
    id: "6206",
    nombre: "Paredones"
  },
  {
    id: "7404",
    nombre: "Parral"
  },
  {
    id: "7106",
    nombre: "Pelarco"
  },
  {
    id: "7203",
    nombre: "Pelluhue"
  },
  {
    id: "8410",
    nombre: "Pemuco"
  },
  {
    id: "7107",
    nombre: "Pencahue"
  },
  {
    id: "8107",
    nombre: "Penco"
  },
  {
    id: "6307",
    nombre: "Peralillo"
  },
  {
    id: "9113",
    nombre: "Perquenco"
  },
  {
    id: "5404",
    nombre: "Petorca"
  },
  {
    id: "6112",
    nombre: "Peumo"
  },
  {
    id: "1405",
    nombre: "Pica"
  },
  {
    id: "6113",
    nombre: "Pichidegua"
  },
  {
    id: "6201",
    nombre: "Pichilemu"
  },
  {
    id: "8411",
    nombre: "Pinto"
  },
  {
    id: "9114",
    nombre: "Pitrufquén"
  },
  {
    id: "6308",
    nombre: "Placilla"
  },
  {
    id: "8412",
    nombre: "Portezuelo"
  },
  {
    id: "12301",
    nombre: "Porvenir"
  },
  {
    id: "1401",
    nombre: "Pozo Almonte"
  },
  {
    id: "12302",
    nombre: "Primavera"
  },
  {
    id: "5105",
    nombre: "Puchuncaví"
  },
  {
    id: "9115",
    nombre: "Pucón"
  },
  {
    id: "10101",
    nombre: "Puerto Montt"
  },
  {
    id: "10302",
    nombre: "Puerto Octay"
  },
  {
    id: "10109",
    nombre: "Puerto Varas"
  },
  {
    id: "6309",
    nombre: "Pumanque"
  },
  {
    id: "4304",
    nombre: "Punitaqui"
  },
  {
    id: "12101",
    nombre: "Punta Arenas"
  },
  {
    id: "10206",
    nombre: "Puqueldón"
  },
  {
    id: "9208",
    nombre: "Purén"
  },
  {
    id: "10303",
    nombre: "Purranque"
  },
  {
    id: "5705",
    nombre: "Putaendo"
  },
  {
    id: "15201",
    nombre: "Putre"
  },
  {
    id: "10304",
    nombre: "Puyehue"
  },
  {
    id: "10207",
    nombre: "Queilén"
  },
  {
    id: "10208",
    nombre: "Quellón"
  },
  {
    id: "10209",
    nombre: "Quemchi"
  },
  {
    id: "8308",
    nombre: "Quilaco"
  },
  {
    id: "8309",
    nombre: "Quilleco"
  },
  {
    id: "8413",
    nombre: "Quillón"
  },
  {
    id: "5501",
    nombre: "Quillota"
  },
  {
    id: "5801",
    nombre: "Quilpué"
  },
  {
    id: "10210",
    nombre: "Quinchao"
  },
  {
    id: "6114",
    nombre: "Quinta de Tilcoco"
  },
  {
    id: "5107",
    nombre: "Quintero"
  },
  {
    id: "8414",
    nombre: "Quirihue"
  },
  {
    id: "6101",
    nombre: "Rancagua"
  },
  {
    id: "8415",
    nombre: "Ránquil"
  },
  {
    id: "7305",
    nombre: "Rauco"
  },
  {
    id: "9209",
    nombre: "Renaico"
  },
  {
    id: "6115",
    nombre: "Rengo"
  },
  {
    id: "6116",
    nombre: "Requínoa"
  },
  {
    id: "7405",
    nombre: "Retiro"
  },
  {
    id: "5303",
    nombre: "Rinconada"
  },
  {
    id: "14204",
    nombre: "Rio Bueno"
  },
  {
    id: "7108",
    nombre: "Río Claro"
  },
  {
    id: "4305",
    nombre: "Río Hurtado"
  },
  {
    id: "11402",
    nombre: "Río Ibáñez"
  },
  {
    id: "10305",
    nombre: "Río Negro"
  },
  {
    id: "12103",
    nombre: "Río Verde"
  },
  {
    id: "7306",
    nombre: "Romeral"
  },
  {
    id: "9116",
    nombre: "Saavedra"
  },
  {
    id: "7307",
    nombre: "Sagrada Familia"
  },
  {
    id: "4204",
    nombre: "Salamanca"
  },
  {
    id: "5601",
    nombre: "San Antonio"
  },
  {
    id: "8416",
    nombre: "San Carlos"
  },
  {
    id: "7109",
    nombre: "San Clemente"
  },
  {
    id: "5304",
    nombre: "San Esteban"
  },
  {
    id: "8417",
    nombre: "San Fabián"
  },
  {
    id: "5701",
    nombre: "San Felipe"
  },
  {
    id: "6301",
    nombre: "San Fernando"
  },
  {
    id: "12104",
    nombre: "San Gregorio"
  },
  {
    id: "8418",
    nombre: "San Ignacio"
  },
  {
    id: "7406",
    nombre: "San Javier"
  },
  {
    id: "10306",
    nombre: "San Juan de la Costa"
  },
  {
    id: "8419",
    nombre: "San Nicolás"
  },
  {
    id: "10307",
    nombre: "San Pablo"
  },
  {
    id: "2203",
    nombre: "San Pedro de Atacama"
  },
  {
    id: "8108",
    nombre: "San Pedro de la Paz"
  },
  {
    id: "7110",
    nombre: "San Rafael"
  },
  {
    id: "8310",
    nombre: "San Rosendo"
  },
  {
    id: "6117",
    nombre: "San Vicente"
  },
  {
    id: "8311",
    nombre: "Santa Bárbara"
  },
  {
    id: "6310",
    nombre: "Santa Cruz"
  },
  {
    id: "8109",
    nombre: "Santa Juana"
  },
  {
    id: "5706",
    nombre: "Santa María"
  },
  {
    id: "5606",
    nombre: "Santo Domingo"
  },
  {
    id: "2103",
    nombre: "Sierra Gorda"
  },
  {
    id: "7101",
    nombre: "Talca"
  },
  {
    id: "8110",
    nombre: "Talcahuano"
  },
  {
    id: "2104",
    nombre: "Taltal"
  },
  {
    id: "9101",
    nombre: "Temuco"
  },
  {
    id: "7308",
    nombre: "Teno"
  },
  {
    id: "9117",
    nombre: "Teodoro Schmidt"
  },
  {
    id: "3103",
    nombre: "Tierra Amarilla"
  },
  {
    id: "12303",
    nombre: "Timaukel"
  },
  {
    id: "8207",
    nombre: "Tirúa"
  },
  {
    id: "2301",
    nombre: "Tocopilla"
  },
  {
    id: "9118",
    nombre: "Toltén"
  },
  {
    id: "8111",
    nombre: "Tomé"
  },
  {
    id: "12402",
    nombre: "Torres del Paine"
  },
  {
    id: "11303",
    nombre: "Tortel"
  },
  {
    id: "9210",
    nombre: "Traiguén"
  },
  {
    id: "8420",
    nombre: "Treguaco"
  },
  {
    id: "8312",
    nombre: "Tucapel"
  },
  {
    id: "14101",
    nombre: "Valdivia"
  },
  {
    id: "3301",
    nombre: "Vallenar"
  },
  {
    id: "5101",
    nombre: "Valparaíso"
  },
  {
    id: "7309",
    nombre: "Vichuquén"
  },
  {
    id: "9211",
    nombre: "Victoria"
  },
  {
    id: "4106",
    nombre: "Vicuña"
  },
  {
    id: "9119",
    nombre: "Vilcún"
  },
  {
    id: "7407",
    nombre: "Villa Alegre"
  },
  {
    id: "5804",
    nombre: "Villa Alemana"
  },
  {
    id: "9120",
    nombre: "Villarrica"
  },
  {
    id: "5109",
    nombre: "Viña del Mar"
  },
  {
    id: "7408",
    nombre: "Yerbas Buenas"
  },
  {
    id: "8313",
    nombre: "Yumbel"
  },
  {
    id: "8421",
    nombre: "Yungay"
  }
];

export const Global = () => {
  return {
    urlApi: "http://192.168.10.59:8080",
    cargos: ["Jefe", "Empleado", "Jarys"],
    escalafon: [
      "ADMINISTRATIVO",
      "ALCALDE",
      "AUXILIAR",
      "DIRECTIVO",
      "JEFATURA",
      "PROFESIONAL",
      "TECNICO",
    ],
    grado: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    motivosModificacion: [
      "Cambio Monto Pactado",
      "Cambio de programa",
      "Extensión fecha término",
      "Cambio de funciones",
      "Horario y jornada",
      "Reemplazo a funcionario",
    ],
  };
};

/**
 *
 * @param {*} rolesAceptados
 *  ["ROL_ADMIN",
    "ROL_ADMIN_MUN",
    "ROL_PRECALIFICADOR",
    "ROL_JC_PRESIDENTE",
    "ROL_JC_SECRETARIO",
    "ROL_JC_REPRESENTANTE",
    "ROL_JC_MIEMBRO_UNO",
    "ROL_JC_MIEMBRO_DOS",
    "ROL_JC_PDTE_ASOC"]
 * @returns TRUE || FALSE
 */
export const Permisos = (rolesAceptados = [], tipo = "menu") => {
  const user = useSelector(selectUser);
  let rolesUsuario = [];

  if (typeof user.user.roles == "undefined") {
    return false;
  } else if (user !== null) {
    rolesUsuario = user.user.roles.split(";");
  } else {
    return false;
  }
  if (
    !rolesAceptados.some((r) => rolesUsuario.includes(r)) &&
    tipo === "redirigir"
  ) {
    localStorage.setItem(
      "error",
      "No tiene los permisos para ingresar a la página."
    );
  } else {
    localStorage.removeItem("error");
  }

  return rolesAceptados.some((r) => rolesUsuario.includes(r));
};

export const Textos = {
  exito_actualizarParticipante: "Funcionario/a actualizado/a con éxito",
  comun_funcionario: "funcionario/a",
  comun_Funcionario: "Funcionario/a",
  comun_FUNCIONARIO: "FUNCIONARIO/A",
  comun_el_funcionario: "el/la funcionario/a",
  comun_Precalificador: "Precalificador/a",
};

export const ListaTiposContratacion = [
  "ABIERTA",
  "DEFINIDA",
  "MODIFICACION",
  "RENOVACION",
];
